export default __webpack_public_path__ + "static/media/button-reset.b78bdf7b.svg";